import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import PropTypes from "prop-types";

/**
 * Primary UI component for user interaction
 */
export const Dropdown = forwardRef((props, ref) => {
  const { label,className, options, name, passSelectValue, preSelectedValue, resetFilters} = props

  const [inputValue, setInputValue] = useState("")
  const [selectedValue, setSelectedValue] = useState(options[0].label)
  const [isOpen, setIsOpen] = useState(false)

  const dropdownRef = useRef();

  useEffect(() => {
    if(!preSelectedValue){
      passSelectValue(name, options[0].value)
    }else{
      var option = options.filter(option => {
        if(option.value === preSelectedValue)
          return option
      })
      //passSelectValue(name, option[0]?.value);
      setSelectedValue(option[0]?.label)
    }
  },[])

  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", checkIfClickedOutside)
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [isOpen])

  const resetFilter = () => {
    setSelectedValue(options[0].label)
  }

  useImperativeHandle(ref, () => ({
    resetFilter,
  }));

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen)
  } 

  const optionSelectionHandler = option => {
    setSelectedValue(option.label)
    setIsOpen(false)
    passSelectValue(name, option.value)
}

  return (
    <div
      ref={dropdownRef}
      className="c-input-dropdown__container"
      onClick={handleDropdownToggle}
    >
      <div className={`c-input ${isOpen ? "isOpen" : ""} dropdown ` + className}>
        <label className="c-input__label">{label}</label>
        <div 
          className='c-input__field c-slider__placeholder'
        >
          <p className="">{selectedValue}</p>
        </div>
        {isOpen ? (
          <ul className="c-dropdown-options__container">
            {options.map(option => {
              return(
                option.label === selectedValue ? (
                  <li
                    className="c-dropdown-options-li u-active"
                    key={option.value} 
                    onClick={() => optionSelectionHandler(option)}
                  >
                    {option.label}
                    <i className="fal fa-check"></i>
                  </li>
                ) : (
                  <li
                    className="c-dropdown-options-li"
                    key={option.value} 
                    onClick={() => optionSelectionHandler(option)}
                  >
                    {option.label}
                  </li> 
                )
              )
            })}
          </ul>
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
});

Dropdown.propTypes = {
  /**
   * label
  */
  label: PropTypes.string,
  /**
   * options
  */
  className: PropTypes.string,
  /**
   * options
  */
  options: PropTypes.array,
};

Dropdown.defaultProps = {
  label: "Label",
  options: [
    {
      value: 17,
      label: "Men- en ruiterroute"
    },
    {
      value:35,
      label: "Menroute",
    },
    {
      value: 36,  
      label: "Ruiterroute"
    },
  ],
  className: "",
  name:"dropdown"
};
